document.addEventListener('DOMContentLoaded', function () {
    var mainToggle = document.getElementById('mainMenuToggle');
    var mobileNav = document.getElementById('mobileNav');
    var mainMenu = document.querySelector('#menu-container');
    var navBg = document.getElementById('nav-bg');
    var logoSvg = document.getElementById('logo-svg');
    var desktopNav = document.getElementById('desktop-nav');
    var desktopNavArrows = desktopNav ? desktopNav.querySelectorAll('svg') : [];
    var navLinks = desktopNav ? desktopNav.querySelectorAll('.nav-link') : [];
    if (mainToggle && mobileNav) {
        mainToggle.addEventListener('click', function (e) {
            e.preventDefault();
            mobileNav.classList.toggle('collapse');
            var expanded = mainToggle.getAttribute('aria-expanded') === 'true';
            mainToggle.setAttribute('aria-expanded', !expanded);
        });
    }

    function setNavColors(isWhite) {
        if (isWhite) {
            navBg.classList.remove('bg-transparent');
            navBg.classList.add('bg-white', 'shadow-sm');
            logoSvg.classList.remove('fill-white');
            logoSvg.classList.add('fill-[#0e3a5e]');
            if (desktopNav) {
                desktopNav.classList.remove('text-gray-200');
                desktopNav.classList.add('text-gray-700');
            }
            if (mainToggle) {
                mainToggle.classList.remove('text-white', 'hover:text-gray-300');
                mainToggle.classList.add('text-gray-900', 'hover:text-gray-700');
            }
            desktopNavArrows.forEach(function(svg) {
                svg.classList.remove('text-gray-200');
                svg.classList.add('text-gray-700');
            });
            navLinks.forEach(function(link) {
                link.classList.remove('text-gray-200');
                link.classList.add('text-gray-700');
            });
        } else {
            navBg.classList.remove('bg-white', 'shadow-sm');
            navBg.classList.add('bg-transparent');
            logoSvg.classList.remove('fill-[#0e3a5e]');
            logoSvg.classList.add('fill-white');
            if (desktopNav) {
                desktopNav.classList.remove('text-gray-700');
                desktopNav.classList.add('text-gray-200');
            }
            if (mainToggle) {
                mainToggle.classList.remove('text-gray-900', 'hover:text-gray-700');
                mainToggle.classList.add('text-white', 'hover:text-gray-300');
            }
            desktopNavArrows.forEach(function(svg) {
                svg.classList.remove('text-gray-700');
                svg.classList.add('text-gray-200');
            });
            navLinks.forEach(function(link) {
                link.classList.remove('text-gray-700');
                link.classList.add('text-gray-200');
            });
        }
    }

    if (mainMenu && mainMenu.classList.contains('nav-dynamic')) {
        window.addEventListener('scroll', function () {
            var isWhite = window.scrollY > window.innerHeight * 0.8;
            setNavColors(isWhite);
        });
        setNavColors(window.scrollY > window.innerHeight * 0.8);
    }

    var submenuToggles = document.getElementsByClassName('submenu-toggle');
    Array.prototype.forEach.call(submenuToggles, function (toggle) {
        var targetId = toggle.getAttribute('data-target').replace('#', '');
        var submenu = document.getElementById(targetId);
        if (submenu) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                submenu.classList.toggle('collapse');
                submenu.classList.toggle('h-0');
                var expanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', !expanded);
            });
        }
    });
});